module.exports = __webpack_public_path__ + "img/rec_arrow.7af97c0d.svg";